import { z } from 'zod';
/**
 * Daemon resource hygiene (PLAN G6 / V26): what vikod reports about its own and its children's
 * subprocesses, file descriptors, sockets, watchers and memory in `machine.status.resources`.
 * Numbers and fixed codes only; alert text travels in doctor-style fix cards (sealed for
 * encrypted accounts like every other `machine.status` text).
 */
export const ResourceLevel = z.enum(['ok', 'warn', 'critical']);
const Count = z.number().int().nonnegative();
const Mb = z.number().nonnegative();
export const MachineResources = z.object({
    /** Sample time. */
    at: z.number().int().nonnegative(),
    level: ResourceLevel,
    /** vikod's open file descriptors (null where the platform cannot count them). */
    fds: Count.nullable(),
    sockets: Count.nullable(),
    /** Soft / hard open-file limit of vikod (hard null = unlimited; both null on Windows). */
    fdSoftLimit: Count.nullable(),
    fdHardLimit: Count.nullable(),
    /** Processes under vikod and its long-lived helpers (Codex app-server). */
    processes: Count,
    zombies: Count,
    /** Orphans of ended runs reaped since vikod started. */
    reaped: Count,
    /** Open file descriptors of those processes, where countable. */
    childFds: Count.nullable(),
    watchers: Count,
    rssMb: Mb,
    childRssMb: Mb,
    helpers: Count,
    /** Alert codes (e.g. `fds`, `processes`, `run.processes`); text is in the fix cards. */
    alerts: z.array(z.string().max(64)).max(32),
    /** New runs are refused while critical (actionable card instead of spawn failures). */
    admitting: z.boolean(),
});
//# sourceMappingURL=resources.js.map